import React, { useState } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import { motion } from 'framer-motion';

import { showPostboxLiveAgentChatDebugSelector } from '../../../selectors';
import { formatLiveAgentTime } from '../../../utils/notification';

import { Decision, Text } from '../../common';
import LiveAgentNotificationMessages from './LiveAgentNotificationMessages';

const useStyles = makeStyles(theme => ({
  container: {
    overflow: 'hidden'
  },
  messages: {
    position: 'relative'
  },
  section: {
    marginTop: theme.spacing(2),
    whiteSpace: 'normal'
  },
  shadow: {
    position: 'absolute',
    left: 0,
    bottom: 0,
    width: '100%',
    height: 80,
    background: 'linear-gradient(180deg, transparent 0%, white 100%)'
  }
}));

const LiveAgentNotificationContent = ({
  isOpen,
  data,
  isClient,
  scrollToNotificationStart
}) => {
  const classes = useStyles();
  const [mountAnimationDone, setMountAnimationDone] = useState(false);

  const { startdatetimeutc, debug, chatEndedBy, casemanager } = data.header;

  const first2Messages = data.chatMessages.slice(0, 2);
  const restMessages = data.chatMessages.slice(2);

  const messagesHidden = !isOpen && data.chatMessages.length > 2;

  const onAnimationComplete = definition => {
    if (definition === 'collapsed') {
      if (mountAnimationDone) {
        scrollToNotificationStart();
      } else {
        setMountAnimationDone(true);
      }
    }
  };

  return (
    <Box className={classes.container}>
      <Text
        translated
        component="span"
        variant="body2"
        color={isClient ? 'secondaryContrast' : 'textHint'}
        className={classes.section}
      >
        POSTBOX_NESTEDCHAT_STARTEDON
      </Text>
      <span> </span>
      <Text
        component="span"
        variant="body2"
        color={isClient ? 'secondaryContrast' : 'textHint'}
        className={classes.section}
      >
        {formatLiveAgentTime(startdatetimeutc)}
      </Text>
      <Decision selector={showPostboxLiveAgentChatDebugSelector}>
        <Box className={classes.section}>
          {debug.map(line => (
            <Text
              key={line}
              component="div"
              variant="body2"
              color="warningLight"
            >
              {line}
            </Text>
          ))}
          <Box>
            <Text
              translated
              component="span"
              variant="body2"
              color="warningLight"
            >
              POSTBOX_NESTEDCHAT_ENDEDBY
            </Text>
            <span> </span>
            <Text component="span" variant="body2" color="warningLight">
              {chatEndedBy}
            </Text>
          </Box>
        </Box>
      </Decision>
      <Box className={classes.messages}>
        <LiveAgentNotificationMessages
          messages={first2Messages}
          startdatetimeutc={startdatetimeutc}
          casemanager={casemanager}
        />
        <motion.section
          key="content"
          variants={{
            open: { height: 'auto' },
            collapsed: { height: 0 }
          }}
          animate={isOpen ? 'open' : 'collapsed'}
          transition={{ duration: 0.3, ease: 'easeInOut' }}
          onAnimationComplete={onAnimationComplete}
        >
          <LiveAgentNotificationMessages
            messages={restMessages}
            startdatetimeutc={startdatetimeutc}
            casemanager={casemanager}
          />
        </motion.section>
        {messagesHidden && <Box className={classes.shadow} />}
      </Box>
    </Box>
  );
};

export default LiveAgentNotificationContent;
